import React, {useContext, useRef, useState} from 'react';
import {getTenant, isJSON} from "@iblai/ibl-web-react-common";
import {
    createCourseAPI, createCourseExtraSection,
    createCourseSection, deleteCourseAPI, setScormCreationAPI,
    updateCourseMetaDataAPI,
    uploadFileToCourseStudio, videoFileUploadAPI
} from "./course";
import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc'; // Import UTC plugin
import timezone from 'dayjs/plugin/timezone';
import {getYouTubeVideoId, isYouTubeVideoUrl} from "../helpers";
import {useNavigate} from "react-router-dom";
import { AppDataContext } from '@iblai/ibl-web-react-common';
import useTeamsAssignments from "../useTeamsAssignments";
dayjs.extend(utc);
dayjs.extend(timezone);

const useProgramCreation = () => {
    const navigate = useNavigate()
    const {notification, setNotification, notificationRef} = useContext(AppDataContext)
    const {getCoursesForSelectDropdown} = useTeamsAssignments()

    const handleSetNotification = (success, msg) => {
        setNotification({
            msg: msg,
            success
        })
    }


    const [submitting, setSubmitting] = useState(false)
    const defaultFields  = {
        program_name:"",
        courses:[],
        //META DATA FIELDS
        description:"",
        duration:"",
        program_banner_image_asset_path:"",//corresponds to url under studio image upload response
        program_card_image_name:"",//corresponds to display_name
        start_date:"",
        display_price:"",
        language:"en",
        credential:false,
        file:"",
        card_image:''
    }
    const [fields, setFields] = useState(defaultFields)
    const defaultStudioImageUploadResponse = {
        "asset": {
            "display_name": "",
            "content_type": "",
            "date_added": "",
            "url": "",
            "external_url": "",
            "portable_url": "",
            "thumbnail": "",
            "locked": false,
            "static_full_url": "",
            "id": ""
        },
        "msg": ""
    }
    const defaultVideoFileUploadResponse = {
        file_url:"",
        name:""
    }
    const [imageCardUploadResponse, setImageCardUploadResponse] = useState(defaultStudioImageUploadResponse)

    const handleFormSubmit = async () => {

        if(!fields.program_name || fields.courses.length < 1){
            handleSetNotification(false,  "Fill out all required fields.")
            return
        }
        setSubmitting(true)
        const currentTenant = localStorage.getItem("current_tenant")
        const org = isJSON(currentTenant) ? JSON.parse(currentTenant)?.org : null
        const platform_key=getTenant()
        const data = {
            org,
            platform_key,
            name:fields.program_name,
            course_list:fields.courses.map((_course)=>(_course.value))
        }
        const programData = await createCourseAPI(data, "program")
        if(!programData?.program_id){
            setSubmitting(false)
            setNotification({
                msg: "An error occurred during initial program creation",
                success: false
            })
            return
        }
        const {program_name, courses, ...metadataFields} = fields

        let parsedFileUploadData = {};
        if(fields.file){
            const formData = new FormData()
            formData.append('file', fields.file)
            const fileUploadData = await uploadFileToCourseStudio(formData, programData.program_id)
            parsedFileUploadData = isJSON(fileUploadData) ? JSON.parse(fileUploadData) : {}
            if(!parsedFileUploadData?.asset?.id){
                setNotification({
                    msg: "An error occurred during image card upload. Course creation still in progress...",
                    success: false
                })
            }
        }

        await updateCourseMetaDataAPI({
            ...metadataFields,
            program_id:programData?.program_id,
            org,
            platform_key,
            ...(parsedFileUploadData?.asset?.id ? {
                card_image:parsedFileUploadData?.asset?.url
            } : {})
        }, "program")

        setSubmitting(false)
        setFields(defaultFields)
        setImageCardUploadResponse(defaultStudioImageUploadResponse)
        const param = new URLSearchParams({
            platform:platform_key,
            key:programData?.program_key
        }).toString()
        navigate(`/studio/authoring/programs/${programData?.program_id}?${param}`, { replace: true })
        setNotification({
            msg: `${fields?.program_name} created successfully.`,
            success: true
        })
    }

    const coursePromiseOptions = (inputValue) => {
        return new Promise((resolve) => {
            getCoursesForSelectDropdown(inputValue, (data) => {
                const result = data?.results;
                if (Array.isArray(result) && result.length > 0) {
                    resolve(
                        result
                            .map((course) => {
                                return {
                                    value: course?.data?.course_id,
                                    label: course?.data.name,
                                };
                            })
                    );
                } else {
                    resolve([]);
                }
            });
        });
    };

    const handleCourseChange = (choice) => {
        setFields({
            ...fields,
            courses: choice,
        });
    };

    return {
        submitting,
        fields,
        setFields,
        imageCardUploadResponse,
        setImageCardUploadResponse,
        handleFormSubmit,
        notificationRef,
        notification,
        coursePromiseOptions,
        handleCourseChange
    }
};

export default useProgramCreation;